// extracted by mini-css-extract-plugin
export default {"tableexample":"tableexample_b240a7b3f8e005279801","table":"table_c1766ee0a26ad37241a5"};